import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { McoRbtLineList } from '@/sc/entities/mcoRbt/McoRbtLineList';

export const McoRbtDetail = () => {
  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'info', label: 'Info', content: <EntityForm /> },
    { id: 'mcoRbtLine', label: 'Rebate Lines', content: <McoRbtLineList mcoRbtId={entityObj.id} /> },
    {
      id: 'validation',
      label: 'Validations',
      content: <ValList parentEntity="MCO_RBT" parentEntityId={entityObj.id} />,
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
